"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Sliders = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M12.17 6H3a1 1 0 0 1 0-2h9.17a3.001 3.001 0 0 1 5.66 0H21a1 1 0 1 1 0 2h-3.17a3.001 3.001 0 0 1-5.66 0ZM14 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-7.83 8H3a1 1 0 1 1 0-2h3.17a3.001 3.001 0 0 1 5.66 0H21a1 1 0 1 1 0 2h-9.17a3.001 3.001 0 0 1-5.66 0ZM8 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-1.83 1H3a1 1 0 1 1 0-2h9.17a3.001 3.001 0 0 1 5.66 0H21a1 1 0 1 1 0 2h-3.17a3.001 3.001 0 0 1-5.66 0Z"
      }
    )
  );
};
export default Sliders;
